import React, { useEffect, useState } from "react";
import { Card, CardBody, Container, CardHeader, CardTitle } from "reactstrap";
import { toast } from "react-toastify";
import { Link, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { FetchReservationDetails } from "../../apis/Reservation";
import { ChevronLeft } from "lucide-react";

const ReservationView = () => {
  const [reservation, setReservation] = useState({});
  const { reservationId } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await FetchReservationDetails(reservationId);

        if (data) {
          console.log("testing");
          console.log("data is : ", data);
          setReservation(data.data.reservation);
        }
      } catch (error) {
        toast.error("Failed to fetch data");
        console.error(error);
      }
    };
    fetchData();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container
          //  h-[calc(100vh-130px)]
          className="px-2 dark:bg-darkBg1 dark:text-[#c7d8eb] "
          fluid
        >
          <div className="flex items-center gap-2">
            <ChevronLeft size={20} className="text-secondaryColor" />
            <Link to={"/reservation"}>Continue managing reservations</Link>
          </div>
          <Card className="max-w-3xl mx-auto">
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-7">
              <CardTitle className="text-2xl font-bold">
                Reservation details
              </CardTitle>
            </CardHeader>
            <CardBody>
              <div className="divide-y">
                <div className="grid grid-cols-2 py-4 first:pt-0 last:pb-0">
                  <div className="text-sm font-medium text-gray-900 dark:text-gray-200">
                    Reservation ID
                  </div>
                  <div>{reservation?._id}</div>
                </div>
                <div className="grid grid-cols-2 py-4">
                  <div className="text-sm font-medium text-gray-900 dark:text-gray-200">
                    Code
                  </div>
                  <div>{reservation.code}</div>
                </div>
                <div className="grid grid-cols-2 py-4">
                  <div className="text-sm font-medium text-gray-900 dark:text-gray-200">
                    Property
                  </div>
                  <div>{reservation.property?.title}</div>
                </div>
                <div className="grid grid-cols-2 py-4">
                  <div className="text-sm font-medium text-gray-900 dark:text-gray-200">
                    Host
                  </div>
                  <div>{`${reservation.host?.firstName} ${reservation.host?.lastName}`}</div>
                </div>
                <div className="grid grid-cols-2 py-4">
                  <div className="text-sm font-medium text-gray-900 dark:text-gray-200">
                    Guest
                  </div>
                  <div>{`${reservation.guest?.firstName} ${reservation.guest?.lastName}`}</div>
                </div>
                <div className="grid grid-cols-2 py-4">
                  <div className="text-sm font-medium text-gray-900 dark:text-gray-200">
                    Check-In
                  </div>
                  <div>
                    {new Date(reservation.checkIn).toLocaleDateString()}
                  </div>
                </div>
                <div className="grid grid-cols-2 py-4">
                  <div className="text-sm font-medium text-gray-900 dark:text-gray-200">
                    Check-Out
                  </div>
                  <div>
                    {new Date(reservation.checkOut).toLocaleDateString()}
                  </div>
                </div>
                <div className="grid grid-cols-2 py-4">
                  <div className="text-sm font-medium text-gray-900 dark:text-gray-200">
                    Total Price
                  </div>
                  <div>${reservation.totalPrice}</div>
                </div>
                <div className="grid grid-cols-2 py-4">
                  <div className="text-sm font-medium text-gray-900 dark:text-gray-200">
                    Reservation State
                  </div>
                  <div>{reservation.reservationState}</div>
                </div>
              </div>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ReservationView;
